export default {"src":"/_next/static/media/CancelIlustration.763870a8.svg","height":778,"width":1099,"blurWidth":0,"blurHeight":0};